export function setFloorplans(state, value) {
  state.floorplans = value;
}
